<template>
  <div>
    <div class="min-vh-100">
      <CRow class="no-gutters px-3 px-sm-0">
        <b-col xl="4" class="text-center text-sm-left mb-3 mb-sm-0">
          <h1 class="mr-sm-4 header-main text-uppercase">รายการหัวข้ออะคาเดมี่</h1>
        </b-col>
        <b-col xl="8" class="text-right">
          <div class="d-flex justify-content-end">
            <b-input-group class="panel-input-serach">
              <b-form-input
                class="input-serach"
                placeholder="ค้นหาหัวข้อ"
                v-model="filter.Search"
                @keyup="handleSearch"
              ></b-form-input>
              <b-input-group-prepend @click="btnSearch">
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" title="View" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
            <router-link to="/academy-topic/details/0">
              <b-button class="btn-main">สร้างหัวข้ออะคาเดมี่</b-button>
            </router-link>
          </div>
        </b-col>
      </CRow>
      <b-row class="no-gutters px-3 px-sm-0 mt-2 overflow-auto">
        <b-col class="">
          <b-button-group class="btn-group-status">
            <b-button
              v-for="(item, index) in statusList"
              :key="index"
              @click="getDataByOrderStatus(item.name, item.id)"
              :class="{ menuactive: isActive(item.name) }"
              >{{ item.name }} ({{ item.count }})</b-button
            >
          </b-button-group>
        </b-col>
      </b-row>
      <div class="mt-3 bg-white px-0 pb-3">
        <b-row class="no-gutters">
          <b-col>
            <b-table
              class="table-list"
              striped
              responsive
              hover
              :items="items"
              :fields="fields"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
            >
              <template v-slot:cell(imageUrl)="data">
                <div class="position-relative">
                  <div
                    class="square-box b-contain"
                    v-bind:style="{
                      'background-image': 'url(' + data.item.imageUrl + ')',
                    }"
                  ></div>
                </div>
              </template>
              <template v-slot:cell(display)="data">
                <div class="d-flex align-items-center"> 
                  <b-form-checkbox
                    v-model="data.item.display"
                    name="check-button"
                    switch
                    size="lg"
                    class="mr-2"
                    @change="onChangeDisplayStatus($event, data.item.id)"
                  ></b-form-checkbox>
                  <span class="mt-2"> {{ data.item.display ? "เปิดใช้งาน" : "ปิดใช้งาน" }} </span>
                </div>
              </template>
              <template v-slot:cell(shareCount)="data">
                <p class="m-0">
                  {{ data.item.shareCount | numeral("0,0") }}
                </p>
              </template>
              <template v-slot:cell(sortOrder)="data">
                <div v-if="data.item.sortOrder == 0">-</div>
                <div v-else>{{ data.item.sortOrder }}</div>
              </template>
              <template v-slot:cell(id)="data">
                <div class="d-flex justify-content-center">
                  <router-link :to="'/academy-topic/details/' + data.item.id">
                    <b-button variant="link" class="text-dark px-1 py-0"
                      >ดูรายละเอียด</b-button
                    >
                  </router-link>
                </div>
              </template>
              <template v-slot:table-busy>
                <div class="text-center text-black my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong class="ml-2">Loading...</strong>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row class="no-gutters px-3 px-sm-0">
          <b-col
            class="form-inline justify-content-center justify-content-sm-between"
          >
            <div class="d-sm-flex m-3">
              <b-pagination
                v-model="filter.PageNo"
                :total-rows="rows"
                :per-page="filter.PerPage"
                class="m-md-0"
                @change="pagination"
                align="center"
              ></b-pagination>
            </div>

            <b-form-select
              class="mr-sm-3 select-page"
              v-model="filter.PerPage"
              @change="hanndleChangePerpage"
              :options="pageOptions"
            ></b-form-select>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";

export default {
  name: "Academytopic",
  components: {
    InputText,
    InputSelect
  },
  data() {
    return {
      statusList: [],
      activeItem: "",
      fields: [
        {
          key: "imageUrl",
          label: "รูปไอคอน",
          class: "w-100px"
        },
        {
          key: "name",
          label: "ชื่อหัวข้อ",
          class: "w-200",
          tdClass: "text-left",
        },
        {
          key: "shareCount",
          label: "จำนวนบทความ",
          class: "w-100px"
        },
        {
          key: "sortOrder",
          label: "ลำดับการแสดง",
          class: "w-100px"
        },
        {
          key: "display",
          label: "สถานะ",
          class: "w-100px"
        },
        {
          key: "id",
          label: "",
          class: "w-100px"
        }
      ],
      items: [],
      isBusy: false,
      rows: 0,
      filter: {
        PageNo: 1,
        PerPage: 10,
        Search: "",
        Status: [],
      },
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" }
      ],
      items: [],
      isBusy: false,
    };
  },
  created: async function() {
    await this.getList();
    this.activeItem = "ทั้งหมด";
  },
  methods: {
    getList: async function() {
      this.isBusy = true;

      let status = await this.$callApi(
        "get",
        `${this.$baseUrl}/api/academy/AcademyStatusWithCount`,
        null,
        this.$headers,
        null
      );

      if (status.result == 1) {
        this.statusList = status.detail;
      }
      
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/academy/list`,
        null,
        this.$headers,
        this.filter
      );
      if (resData.result == 1) {
        this.items = resData.detail.dataList;
        this.rows = resData.detail.count;

        this.isBusy = false;
        this.$isLoading = true;
      }
    },
    onChangeDisplayStatus: async function (value, id) {
      var data = {
        status: value,
      };
      let resData = await this.$callApi(
        "post",
        `${this.$baseUrl}/api/academy/display/${id}`,
        null,
        this.$headers,
        data
      );
      if (resData.result == 1) {
        this.getList();
      }
    },
    getDataByOrderStatus(status, id) {
      this.activeItem = status;
      this.filter.Status = [];
      if (id != 0) this.filter.Status.push(id);
      this.getList();
    },
    isActive: function(menuItem) {
      return this.activeItem == menuItem;
    },
    pagination(Page) {
      this.filter.PageNo = Page;
      this.getList();
    },
    hanndleChangePerpage(value) {
      this.filter.PageNo = 1;
      this.filter.PerPage = value;
      this.getList();
    },
    handleSearch(e) {
      if (e.keyCode === 13) {
        this.filter.PageNo = 1;
        this.getList();
      }
    },
    btnSearch() {
      this.filter.PageNo = 1;
      this.getList();
    },
    hanndleStatusList(value) {
      this.filter.PageNo = 1;
      this.filter.statusId = value;
      this.getList();
    },
  }
};
</script>

<style scoped>
.menuactive {
  color: #ffb300 !important;
}
</style>
